import Navigator from './Navbar'
import Routing from './Routeing'
import { BrowserRouter as Router } from "react-router-dom"
import './App.css'
import React from 'react'

function App() {
  // useEffect(() => {
  //   const handleBeforeUnload = () => {
  //     localStorage.clear()
  //   }

  //   window.addEventListener("beforeunload", handleBeforeUnload)

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload)
  //   }
  // }, [])
  
  return (
    <Router>
      <div className="root" style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "var(--bg-main)",
        fontFamily: "var(--font-primary)"
      }}>
        <header className="App-header" style={{ position: "sticky", top: 0, zIndex: 100 }}>
          <Navigator />
        </header>
        <main style={{
          flex: 1,
          display: "flex",
          flexDirection: "column"
        }}>
          <Routing />
        </main>
      </div>
    </Router>
  );
}

export default App;
